import { useEffect, useRef, type FC } from "react";
import { IconButton, Modal, type ModalProps } from "@telegram-apps/telegram-ui";
import { IconClose } from "~/components/Iconfont/Iconfont";
import clsx from "clsx";
import "./BaseModal.css";
import { postEvent } from "@telegram-apps/sdk-react";

export const enum TitleType {
    title = "title",
    close = "close",
}
export interface BaseModalProps extends ModalProps {
    /** 标题类型  */
    titleType?: "title" | "close";
    /** 标题关闭按钮的点击事件 */
    onclickHeaderClose?: (bool: boolean) => void;
    /** 标题 方式 */
    titleAlign?: "center" | "left";
    overlayClassName?: string;
}

export const BaseModal: FC<BaseModalProps> = (props) => {
    const { titleType, overlayClassName = "" } = props;
    const headerDom = () => {
        if (props.header) return props.header;
        if (titleType == TitleType.title) {
            return (
                <div className="block h-[60px] p-0  relative px-4">
                    <div
                        className={clsx(
                            "h-[60px] flex items-center text-h6 font-Semibold text-text_1",
                            {
                                "justify-center": props.titleAlign == "center",
                            }
                        )}
                    >
                        {props.title}
                    </div>
                    <div
                        className="absolute right-0 top-0 p-4"
                        onClick={() => {
                            props.onclickHeaderClose &&
                                props.onclickHeaderClose(false);
                        }}
                    >
                        <IconButton
                            className=" rounded-full bg-icon_close_bg p-[6px]"
                            mode="gray"
                            size="s"
                        >
                            <IconClose className="text-text_2 text-[16px]" />
                        </IconButton>
                    </div>
                </div>
            );
        }
        if (titleType == TitleType.close) {
            return (
                <div className="block h-[60px] p-0  relative px-4">
                    <div
                        className="absolute right-0 top-0 p-4"
                        onClick={() => {
                            props.onclickHeaderClose &&
                                props.onclickHeaderClose(false);
                        }}
                    >
                        <IconButton
                            className=" rounded-full bg-icon_close_bg p-[6px]"
                            mode="gray"
                            size="s"
                        >
                            <IconClose className="text-text_2 text-[16px]" />
                        </IconButton>
                    </div>
                </div>
            );
        }
    };
    const refScrollY = useRef(0);

    useEffect(() => {
        try {
            if (!props.open) return;
            postEvent("web_app_expand");
            setTimeout(() => {
                refScrollY.current = window.scrollY;
                window.scrollTo(window.scrollX, window.scrollY + 1);
            }, 30);
        } catch (error) {
            console.error(error);
        }

        return () => {
            window.scrollTo(window.scrollX, refScrollY.current);
        };
    }, [props.open]);

    // return (
    //     <div
    //         className={clsx(
    //             'fixed w-full inset-0 !bg-overlay_bg z-[100]',
    //             {
    //                 hidden: !props.open,
    //                 // 'translate-y-[0vh]': props.open,
    //             },
    //         )}
    //         onClick={(event) => {
    //             event.stopPropagation()
    //             event.preventDefault()
    //             return false
    //         }}
    //     >
    //         {/* content */}
    //         <div
    //             className={clsx(
    //                 'fixed  bottom-0 w-full max-h-[90%] bg-bg_0 rounded-tl-[16px] rounded-tr-[16px] drawer',
    //                 props.open ? 'show' : 'hide',
    //             )}
    //         >
    //             {headerDom()}
    //             {props.children}
    //         </div>
    //     </div>
    // )

    return (
        <Modal
            {...props}
            header={headerDom()}
            overlayComponent={
                props.overlayComponent || (
                    <Modal.Overlay
                        className={clsx(
                            "!bg-overlay_bg z-[100]",
                            overlayClassName
                        )}
                    ></Modal.Overlay>
                )
            }
        />
    );
};
